export const initShoppingCart = () => {
  const shoppingCart = localStorage.getItem("shoppingCart");
  if (!shoppingCart) return "{}";
  return shoppingCart;
}